'use client';

import { LanguageSwitcher } from '@/components/language-switcher';
import type { CatalogLanguageMode } from '@/components/catalog-language-forcer';

import type { buttonVariants } from '@/components/ui/button';
import type { VariantProps } from 'class-variance-authority';

type CatalogLanguageToggleProps = {
  mode: CatalogLanguageMode;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  className?: string;
};

export function CatalogLanguageToggle({ mode, variant = 'ghost', className }: CatalogLanguageToggleProps) {
  if (mode !== 'user') {
    return null;
  }
  return <LanguageSwitcher variant={variant} className={className} />;
}
